module.exports = __webpack_public_path__ + "img/center-image.9efeb53c.png";